module.exports = __webpack_public_path__ + "img/in.11de0b25.svg";